import React from "react";
import { Box, Typography, Stack, Link, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { useLanguage } from "../../context/LanguageContext";
export default function SobreMi({ id }) {
  const theme = useTheme();
  const { language } = useLanguage();

  const translations = {
    es: {
      title: "Sobre Mí",
      paragraph1:
        "Inicié mi carrera en la programación con mucho amor, pero la vida me llevó por otros caminos laborales. Durante mi ausencia en la programación, gestioné y manejé datos en bodegas y logística de personal. Hoy en día estoy deseoso de continuar con aquella pasión que despertó la programación unos años atrás.",
      paragraph2:
        "Actualmente me encuentro estudiando y avanzando en el desarrollo de mi carrera en programación.",
      contactPart1: "Te dejo mi ",
      contactPart2: " para que veas más a fondo mi experiencia laboral.",
    },
    en: {
      title: "About Me",
      paragraph1:
        "I started my programming career with great passion, but life led me down other work paths. During my time away from programming, I managed and handled data in warehouses and personnel logistics. Nowadays, I am eager to continue with the passion that programming awakened in me years ago.",
      paragraph2:
        "Currently, I am studying and progressing in the development of my programming career.",
      contactPart1: "Here is my ",
      contactPart2: " so you can see more about my work experience.",
    },
  };

  return (
    <Box
      id={id}
      component="section"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: { xs: 3, sm: 4, md: 6 },
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        transition: "background-color 0.3s ease, color 0.3s ease",
        position: "relative",
      }}
    >
      <Box
        data-aos="fade-up-left"
        sx={{
          maxWidth: "800px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontFamily: theme.typography.fontFamily[0],
            fontWeight: 700,
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
            background: theme.palette.secondary.main,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 2,
            textTransform: "uppercase",
          }}
        >
          {translations[language].title}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.primary,
            lineHeight: 1.7,
            fontSize: { xs: "1rem", sm: "1.1rem" },
            maxWidth: "700px",
          }}
        >
          {translations[language].paragraph1}
          <br />
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            fontStyle: "italic",
            color: theme.palette.text.secondary,
            fontSize: { xs: "1rem", sm: "1.1rem" },
            maxWidth: "700px",
          }}
        >
          {translations[language].paragraph2}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.primary,
            fontSize: { xs: "0.95rem", sm: "1rem" },
            maxWidth: "700px",
          }}
        >
          {translations[language].contactPart1}
          <Link
            href="https://www.linkedin.com/in/hernan-dario-gomez-marquez-b12958203/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              color: theme.palette.secondary.main,
              fontWeight: 600,
              "&:hover": {
                color: theme.palette.error.main,
              },
            }}
          >
            LinkedIn
          </Link>{" "}
          {translations[language].contactPart2}
        </Typography>

        <Stack
          direction="row"
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 1 }}
        >
          <Link
            href="https://www.linkedin.com/in/hernan-dario-gomez-marquez-b12958203/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: theme.palette.secondary.main,
              fontWeight: 500,
              textDecoration: "none",
              transition: "all 0.3s ease",
              "&:hover": {
                color: theme.palette.error.main,
                transform: "translateY(-2px)",
              },
            }}
          >
            <FontAwesomeIcon icon={faLinkedin} style={{ fontSize: "1.4rem" }} />
            <Typography variant="body1">LinkedIn</Typography>
          </Link>
        </Stack>
      </Box>
    </Box>
  );
}
